<div *ngIf="visible" class="pad-L"><ng-content></ng-content></div>
